var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.validVendor)?_c('figure',{staticClass:"logo"},[_c('img',{staticClass:"image",attrs:{"src":`${_vm.$root.$data.STATIC_ROOT}images/vendor/${_setup.src}`}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }